<template>
    <div class="border-b-[1px]">
      <slot></slot>
    </div>
</template>

<script>
import DownloadFile  from '../../../assets/icons/download-file.svg'
const iconMap = {
  'DownloadFile': DownloadFile
}

export default {
  name: 'IntAccordion',
  methods: {
   iconHref(key) {
      if (iconMap[key]) return '#' + iconMap[key].id
      return null
    },
  }
}
  
</script>

